import { imgDownloadApp } from 'assets/images';
import { iconAppStore, iconGGPlay } from 'assets/icons';
import React from 'react';

const DownloadBVLife = () => {
	return (
		<div className='mt-16px flex justify-between items-end bg-white rounded-8px border border-EEEEEE py-15px pl-24px pr-10px md:shadow-md overflow-hidden'>
			<div className=''>
				<p className='text-434343 text-18px font-averta-bold leading-23px'>
					Tải ứng dụng MyBVLife
				</p>
				<p className='text-14px text-black leading-16px mt-13px'>
					Tìm kiếm trên Google Play hoặc App Store với từ khóa “MyBVLife” hoặc
					bấm vào đây để tải
				</p>
				<div className='flex items-center mt-17px gap-5px'>
					<ItemLink link={"https://apps.apple.com/us/app/mybvlife/id1438384821"} image={iconAppStore} />
					<ItemLink link={"https://play.google.com/store/apps/details?id=com.baoviet.mybvlife"} image={iconGGPlay} />
				</div>
			</div>
			<div className='w-105px h-105px bg-14968E flex-shrink-0 -mb-15px'>
				<img src={imgDownloadApp} alt='' />
			</div>
		</div>
	);
};

export const ItemLink = ({ link, image }) => {
	return (
		<a href={link} target='_blank'>
			<img
				className='h-30px hover:shadow-md hover:opacity-80 transition-all duration-200 transform hover:scale-102'
				src={image}
				alt=''
			/>
		</a>
	);
};

export default DownloadBVLife;
